import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SalesComponent } from './sales/sales.component';
import { ServicesComponent } from './services/services.component';
import { PrepressComponent } from './prepress/prepress.component';
import { PlantComponent } from './plant/plant.component';
import { EnvironmentComponent } from './environment/environment.component';
import { ContactComponent } from './contact/contact.component';
import { TeamComponent } from './team/team.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: HomeComponent },
  { path: 'sales', component: SalesComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'prepress', component: PrepressComponent },
  { path: 'plant', component: PlantComponent },
  { path: 'environment', component: EnvironmentComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'team', component: TeamComponent },
  { path: 'downloads', component: DownloadsComponent },
  { path: 'privacypolicy', component: PrivacypolicyComponent },
  { path: 'terms', component: TermsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts